var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenExpired(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965",
    transform: "translate(-627 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(627 285)",
    fill: "#fff",
    stroke: "#004f71",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "expired-svgrepo-com",
    transform: "translate(653.436 311)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 20.176,
    cy: 20.176,
    r: 20.176,
    transform: "translate(0 0)",
    fill: "#005074"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 16.852,
    cy: 16.852,
    r: 16.852,
    transform: "translate(3.324 3.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6063",
    "data-name": "Rectangle 6063",
    width: 2.881,
    height: 12.971,
    transform: "translate(18.738 7.204)",
    fill: "#005074"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6064",
    "data-name": "Rectangle 6064",
    width: 3.457,
    height: 9.8,
    transform: "translate(18.952 21.389) rotate(-45)",
    fill: "#005074"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 2.881,
    cy: 2.881,
    r: 2.881,
    transform: "translate(17.295 17.295)",
    fill: "#005074"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 1.443,
    cy: 1.443,
    r: 1.443,
    transform: "translate(18.732 18.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41128",
    "data-name": "Path 41128",
    d: "M26.262,74.532,47.02,39.8a2.839,2.839,0,0,1,4.9,0L72.671,74.532a2.875,2.875,0,0,1-2.453,4.324h-41.5a2.875,2.875,0,0,1-2.453-4.324Z",
    transform: "translate(-13.439 -18.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41129",
    "data-name": "Path 41129",
    d: "M69.2,79.315H27.7a4.353,4.353,0,0,1-3.783-2.251,4.229,4.229,0,0,1,.065-4.282L44.725,38.025A4.454,4.454,0,0,1,48.633,35.9a4.157,4.157,0,0,1,3.564,2.15L72.931,72.782a4.229,4.229,0,0,1,.053,4.318A4.342,4.342,0,0,1,69.2,79.315ZM48.5,38.869a1.431,1.431,0,0,0-1.235.695L26.509,74.3a1.3,1.3,0,0,0,0,1.33,1.366,1.366,0,0,0,1.188.731H69.2a1.366,1.366,0,0,0,1.188-.731,1.3,1.3,0,0,0,0-1.33L49.6,39.522a1.188,1.188,0,0,0-1.051-.624Z",
    transform: "translate(-12.422 -17.315)",
    fill: "#005074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41130",
    "data-name": "Path 41130",
    d: "M61.718,81.44a1.853,1.853,0,0,1,.166-.867c.143-.285.291-.434.434-.719s.434-.291.719-.434a1.853,1.853,0,0,1,.867-.143,2.494,2.494,0,0,1,1.01.143,1.653,1.653,0,0,1,1.128,1.152,1.853,1.853,0,0,1,.143.867,1.829,1.829,0,0,1-.143.861c-.143.291-.291.434-.434.725s-.434.285-.719.434a2.168,2.168,0,0,1-1.01.143c-.434,0-.719,0-.867-.143s-.594-.291-.719-.434a3.225,3.225,0,0,1-.41-.725A1.829,1.829,0,0,1,61.718,81.44Zm4.033-4.466H62.437L61.885,62.85h4.324Z",
    transform: "translate(-27.995 -28.26)",
    fill: "#005074"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenExpired);
export default __webpack_public_path__ + "static/media/token-expired.cfc22906.svg";
export { ForwardRef as ReactComponent };